<script setup lang="ts">
import { MapState, useStore } from '@/store/Store';
import { computed } from 'vue';

const store = useStore();

const working = computed(() => {
	const s: MapState = store.mapState;
	return s == MapState.Loading || s == MapState.Saving;
});

</script>


<template>
	<transition name="fade">
		<div v-if="working" class="working">
			<div class="spinner"></div>
		</div>
	</transition>
</template>


<style scoped>
.working {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	backdrop-filter: grayscale(30%) blur(1px) brightness(60%);
	background: rgba(0, 0, 0, 0.0);
	z-index: 3000;

	display: flex;
	align-items: center;
	justify-content: center;
}
</style>